module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Medium.2a42a66a.woff";